export type ModalWrapperProps = {
  busy?: boolean;
  buttonsDisabled?: boolean;
  cancelButtonLabel?: string;
  closeOnOkClick?: boolean;
  displayCancelButton?: boolean;
  displayFooter?: boolean;
  okButtonDisabled?: boolean;
  okButtonLabel?: string;
  contentOverflowY?: 'visible' | 'auto';
  size?: ModalSize;
  showHeader?: boolean;
  header?: string;
  draggable?: boolean;
  position?: 'top' | 'center' | 'bottom';
};

export type ModalWrapperExpose = {
  show: () => void;
  hide: () => void;
};

export enum ModalSize {
  XL = 'xl',
  L = 'lg',
  M = 'sm',
}
